<template>
    <div v-if="isAccepted || (canAccept && !isTop)"
        :class="isAccepted ? 'f-icon-accept' : 'f-icon-accept-not'"
        @click="accept">
        {{tip}}
    </div>
</template>

<style lang="less">
    @import '../assets/less/components/accept-icon.less';
</style>

<script>
import {mapGetters} from 'vuex';

export default {
    props: {
        isAccepted: {
            'type': Number,
            'default': 0
        },
        isTop: {
            'type': Number,
            'default': 0
        }
    },
    computed: {
        ...mapGetters(['canAccept']),
        tip: {
            get() {
                return this.isAccepted ? '已采纳' : '采纳';
            }
        }
    },
    methods: {
        accept() {
            if (!this.isAccepted) {
                this.$emit('accept');
            }
        }
    }
};
</script>